import React from "react";
import { useIntl } from "react-intl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import { faInstagram } from "@fortawesome/free-brands-svg-icons";
import { Button } from "reactstrap";
import { useRouterCore } from "../../../cores/router";
import { useGlobalCore } from "../../../cores/globals";
import { useMeCore } from "../../../cores/me";
import { isFacebookMessagingConnected, isSocialMessagingConnected } from "../../../cores/socialPost/config";
import { useFacebookCore } from "../../../cores/facebook";
import "./WebChatEmptyState.scss";

const BULLET_KEYS = [
  "app.chat.emptyState.bullet1",
  "app.chat.emptyState.bullet2",
  "app.chat.emptyState.bullet3",
  "app.chat.emptyState.bullet4",
] as const;

export default function WebChatEmptyState() {
  const intl = useIntl();
  const { goToBinding } = useRouterCore();
  const { isDarkMode } = useGlobalCore();
  const { socialSettings } = useMeCore();
  const { settings: facebookSettings } = useFacebookCore();
  const socialMessagingConnected =
    isSocialMessagingConnected(socialSettings) ||
    Boolean(facebookSettings?.token);

  return (
    <div
      className={`webchat-empty-state ${
        isDarkMode ? "webchat-empty-state--dark" : ""
      }`}
    >
      <div className="webchat-empty-state__card">
        <div className="webchat-empty-state__hero-icon" aria-hidden>
          <FontAwesomeIcon icon={faInstagram} size="3x" />
        </div>
        <h2 className="webchat-empty-state__title">
          {intl.formatMessage({ id: "app.chat.emptyState.title" })}
        </h2>
        <p className="webchat-empty-state__subtitle">
          {socialMessagingConnected
            ? intl.formatMessage({ id: "app.chat.emptyState.subtitleConnected" })
            : intl.formatMessage({ id: "app.chat.emptyState.subtitle" })}
        </p>
        <ul className="webchat-empty-state__list">
          {BULLET_KEYS.map((id) => (
            <li key={id}>
              <FontAwesomeIcon
                icon={faCheckCircle}
                className="webchat-empty-state__check"
              />
              {intl.formatMessage({ id })}
            </li>
          ))}
        </ul>
        {!socialMessagingConnected && (
          <>
            <Button
              color="primary"
              className="webchat-empty-state__cta rounded-pill px-4 py-2"
              onClick={goToBinding}
            >
              <FontAwesomeIcon icon={faInstagram} className="me-2" />
              {intl.formatMessage({ id: "app.chat.emptyState.ctaInstagram" })}
            </Button>
            <p className="webchat-empty-state__footnote">
              {intl.formatMessage({ id: "app.chat.emptyState.hint" })}
            </p>
          </>
        )}
      </div>
    </div>
  );
}
